import React, { useState } from "react";
import styles from "./CustomAlertPopup.module.scss";
import Text from "components/text/Text";
import { getAllClassNames } from "helpers";
import Button from "components/buttons/button/Button";
import { grad1, grad2 } from "assets/constants";
import { ArrowLeftBlue} from "assets/icons";

type ICustomAlertPopup = {
  title?: string;
  titeStyle?: React.CSSProperties;
  paragraphs?: {text: string | React.ReactNode , style?: React.CSSProperties, isHtml?: boolean}[];
  toggledTextExpand?: string;
  toggledTextTitleStyle?: React.CSSProperties;
  toggledTextCollapse?: string;
  toggledText?: string;
  showButton?: boolean;
  buttonText: string; 
  onClose: () => void;
};

export const CustomalertPopup = ({
  title,
  titeStyle,
  paragraphs,
  toggledTextExpand,
  toggledTextTitleStyle,
  toggledTextCollapse = '',
  toggledText,  
  showButton,
  buttonText, 
  onClose,
}: ICustomAlertPopup) => {

  const [isToggle, setIsToggles] = useState(false);

  return (
    <div className={getAllClassNames(["ais-SearchBox", styles.container])}>
      <Text className={styles.title} text={title} style={titeStyle}/>
      {paragraphs && paragraphs.map((p, i) => (
        p.isHtml ? <div 
          key={i} 
          style={p.style}
          dangerouslySetInnerHTML={{ 
            __html: typeof p.text === 'string' ? p.text : '' 
          }}
        /> : 
        <Text key={i} text={p.text} style={p.style}/>
      ))}
      {!isToggle && toggledText && <><Text style={toggledTextTitleStyle} text={toggledTextExpand} onClick={() => setIsToggles(true)}/><ArrowLeftBlue className={styles.arrowExpand} onClick={() => setIsToggles(true)} /></>}
      {isToggle && toggledText && <Text text={toggledText} />}
      {isToggle && <><Text style={toggledTextTitleStyle} text={toggledTextCollapse} onClick={() => setIsToggles(false)}/><ArrowLeftBlue className={styles.arrowExpanded} onClick={() => setIsToggles(false)} /></>}
      {showButton &&
        <Button
          replaceClassName={styles.button}
          color1={grad1}
          color2={grad2}
          text={buttonText}
          onClick={() => onClose()} />
      }
    </div>
  );
};
